import { Info } from "lucide-react";
import { Tooltip } from "@/components/atoms/Tooltip";
import { cn } from "@/lib/cn";

/**
 * Small info icon that carries a heading's or field label's explanation. Sits
 * next to the text it explains, so the hint is discoverable without the whole
 * control becoming a hover target.
 */
export function InfoHint({
  content,
  side = "top",
  size = 13,
  className,
}: {
  content: string;
  side?: "top" | "right" | "bottom" | "left" | "bottom-right";
  size?: number;
  className?: string;
}) {
  return (
    <Tooltip content={content} side={side}>
      <span
        // tabIndex so the hint is reachable by keyboard, not just by pointer.
        tabIndex={0}
        aria-label={content}
        className={cn(
          "inline-flex shrink-0 cursor-help align-middle text-bridge-subtle transition-colors hover:text-bridge-muted focus:outline-none focus-visible:text-bridge-muted",
          className,
        )}
      >
        <Info size={size} aria-hidden />
      </span>
    </Tooltip>
  );
}
